import { ComplexControl } from '../../../../vas/controls/complex/complex-control.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';
import { FormManagerPageReducerHelper } from '../form-manager-page.reducer-helper';

export const subControlFormSubmitReducer = (
    state = initialState,
    action: actions.SubControlFormSubmit
): State => {
    return {
        ...state,
        controlForm: {
            control: FormManagerPageReducerHelper.updateSubControl(
                state.subControlForm.control as ComplexControl,
                action.payload.control
            )
        },
        subControlForm: {
            control: undefined,
            subControl: undefined
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/sub-control-form-submit.reducer.ts